import { UploadExcel as GenericUploadExcel } from '../../../components/UploadExcel';
import { ProductService as Service } from './ProductService';

export const UploadExcel = ({ display, setDisplay, reloadLazyData }) => {
  return (
    <GenericUploadExcel
      display={display}
      setDisplay={setDisplay}
      reloadLazyData={reloadLazyData}
      service={Service}
      header="Upload file Excel sản phẩm"
      resultHeader="Kết quả upload Excel sản phẩm"
    />
  );
};